import { classNameParser } from "../../../helpers";
import { Props } from "../../../types";

import "./style.css";

type SkeletonRowProps = Props<{
  size: "small" | "medium" | "large";
}>;

const SkeletonRow = (props: SkeletonRowProps) => (
  <div className={classNameParser(`skeleton-row skeleton-row--${props.size}`, props.className)} style={props.style} />
);

export const DashboardSkeleton = (props: Props) => (
  <div className={props.className} style={props.style}>
    <SkeletonRow className="mb-[73px]" size="small" />
    <SkeletonRow className="mb-[11px]" size="large" />
    <SkeletonRow className="mb-[22px]" size="medium" />
    <SkeletonRow className="mb-[11px]" size="large" />
    <SkeletonRow size="medium" />
  </div>
);
